// import { ECndnType } from '@/enums/ECndn';
import { ICndnFreeForm } from '@/interfaces/cndnFreeForm';
import { formatThaiDate } from '@/utils/dataUtils';
import React from 'react';

interface IProps {
  cndn: ICndnFreeForm;
}

const TemplateCndnInfoSecond = ({ cndn }: IProps) => {
  return (
    <div className="flex w-full text-xs mt-2">
      <table
        border={1}
        cellSpacing={0}
        cellPadding={5}
        style={{
          width: '100%',
          border: '0.5px; black solid',
          borderCollapse: 'collapse',
        }}
      >
        <tr>
          {/* <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              {docNameTH} <br />
              {docNameEN}
            </strong>
          </td> */}
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              อ้างอิง เลขที่ใบแจ้งหนี้ <br /> Invoice No.
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              อ้างอิง วันที่สั่งซื้อ <br /> Invoice Date
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              อ้างอิง ใบสั่งซื้อ <br /> Sales PO No.
            </strong>
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            <strong>
              พนักงานขาย <br /> Salesman
            </strong>
          </td>
        </tr>
        <tr>
          {/* <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {cndn?.code}
          </td> */}
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {cndn?.ivNo}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {formatThaiDate(cndn?.docDate)}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {cndn?.poNo}
          </td>
          <td
            style={{
              border: '1px solid black',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
          >
            {cndn?.salesName}
          </td>
        </tr>
      </table>
    </div>
  );
};

export default TemplateCndnInfoSecond;
